const indexItems = [
  { title: '韩漫恋爱', count: '1,286部', icon: 'ri-heart-line', color: 'primary' },
  { title: '日漫悬疑', count: '892部', icon: 'ri-search-eye-line', color: 'accent' },
  { title: '国漫玄幻', count: '1,054部', icon: 'ri-sword-line', color: 'primary' },
  { title: '完结经典', count: '2,340部', icon: 'ri-bookmark-line', color: 'accent' },
  { title: '都市言情', count: '968部', icon: 'ri-building-line', color: 'primary' },
  { title: '搞笑日常', count: '723部', icon: 'ri-emotion-laugh-line', color: 'accent' },
  { title: '热血少年', count: '1,512部', icon: 'ri-fire-line', color: 'primary' },
  { title: '穿越异界', count: '645部', icon: 'ri-arrow-left-right-line', color: 'accent' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
            漫画索引
          </h2>
          <p className="text-sm text-foreground-500">虫虫漫画全部分类一览，快速找到你想看的漫画类型</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-300 transition-colors cursor-pointer group text-center"
            >
              <div
                className={`w-10 h-10 mx-auto mb-3 rounded-xl flex items-center justify-center ${
                  item.color === 'primary' ? 'bg-primary-100 text-primary-600' : 'bg-accent-100 text-accent-600'
                }`}
              >
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
              <span className="text-xs text-foreground-400">{item.count}</span>
            </div>
          ))}
        </div>

        <div className="text-center mt-6">
          <span className="inline-flex items-center gap-1.5 text-sm text-primary-600 font-medium cursor-pointer hover:text-primary-700 transition-colors whitespace-nowrap">
            浏览全部分类
            <i className="ri-arrow-right-line text-sm"></i>
          </span>
        </div>
      </div>
    </section>
  );
}